import axios from "axios";
import React, { useEffect } from "react";
import GetServerAddress from "../../functions/GetServerAddress";

export function Get_limited_Choose_Fields_With_Sort_From_MongoDB(
  dbName,
  collctiontext,
  limit,
  sort,
  setdata,
  fields,
  logout
) {
  const fetchData = async () => {
    try {
      const response = await axios.post(
        GetServerAddress() +
          "api/staff/Get_limited_Choose_Fields_With_Sort_From_MongoDB",
        {
          dbName: dbName,
          collctiontext: collctiontext,
          limit: limit,
          fields: fields,
          sort: sort,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("Token")}`, // Include the JWT token in the request headers
            username: localStorage.getItem("Username"),
            activitylog: "No",
          },
        }
      );
      console.log("Response Data: ", response);
      // Check for specific server response indicating an invalid auth token
      if (response.data.status === 403 || response.data.status === 401) {
        logout();
        return; // Stop further execution in case of invalid auth token
      }
      setdata(response.data.data); // Update your state with the fetched data
    } catch (error) {
      console.error("Error fetching data: ", error);
      window.alert(
        "Error Getting data, please speak to Admin if this issue persists: ",
        error
      );
    }
  };

  fetchData();
} // Empty dependency array means this effect runs only once
